import { User } from 'model/User';
import { Contractor } from 'model/Contractor';
import { Report } from 'model/Report';
import { WorkResource } from 'model/WorkResource';
import { ResourceParam } from 'model/Resource';

export const ledgerStatusList = [
  { value: 0, label: '新規' },
  { value: 1, label: '見積提出済' },
  { value: 2, label: '受注' },
  { value: 3, label: '施工中' },
  { value: 4, label: '完了' },
  { value: 5, label: '失注' },
];

export const ledgerPaymentStatusList = [
  { value: 1, label: '未請求' },
  { value: 2, label: '出来高請求' },
  { value: 3, label: '請求完了' },
  { value: 4, label: '入金完了' },
  { value: 0, label: '請求なし' },
];

export type LedgerStatus = typeof ledgerStatusList[number];

export type LedgerPaymentStatus = typeof ledgerPaymentStatusList[number];

export const orderList = [
  { value: 0, label: '元請' },
  { value: 1, label: '1次' },
  { value: 2, label: '2次' },
  { value: 3, label: '3次' },
];

export const safetyDocumentTypeList = [
  { value: 'paper', label: '紙' },
  { value: 'gs', label: 'GS' },
  { value: 'gf', label: 'GF' },
  { value: 'buildee', label: 'Buildee' },
  { value: 'other', label: 'その他（手入力）' },
];

export const manifestoTypeList = [
  { value: 'paper', label: '紙' },
  { value: 'digital', label: '電子' },
];

export type LedgerMember = {
  id: number;
  ledgerId: Ledger['id'];
  memberId: number;
  salary: number;
  name?: string;
};

export type Ledger = {
  id: number;
  name: string;
  shortName: string;
  startDate?: number;
  endDate?: number;
  summary: string;
  address: string;
  leaderId: User['id'];
  safetyOfficerId: User['id'];
  order: number;
  orderingParty: string | null;
  primeContractorId: number;
  price: number;
  status: LedgerStatus['value'];
  paymentStatus: LedgerPaymentStatus['value'];
  remarks: string;
  safetyDocumentType: (typeof safetyDocumentTypeList)[number]['value'];
  safetyDocumentTypeText?: string;
  manifestoType: (typeof manifestoTypeList)[number]['value'];
  resourceCode: string;
  leader?: User;
  safetyOfficer?: User;
  primeContractor?: Contractor;
  members?: LedgerMember[];
  reports?: Report[];
  resources?: ResourceParam[];
  costs?: { type: WorkResource['type'] | 'user' | 'partner', cost: number }[];
};
